import woltInstance from '../instance'

const storeWoltDriverIntegrations = (data) => {
  return woltInstance.post('/driverIntegrations', data)
}

export default storeWoltDriverIntegrations
